import { ReactNode } from 'react';

export const LAYOUT_EVENT = 'event';
export const LAYOUT_DEFAULT = 'default';
export const LAYOUT_EMPTY = 'empty';
export const LAYOUT_EMPTY_FULL = 'empty-full';
export const LAYOUT_WITHOUT_SIDEBAR = 'without-sidebar';
export type LayoutType =
  | typeof LAYOUT_EVENT
  | typeof LAYOUT_DEFAULT
  | typeof LAYOUT_EMPTY
  | typeof LAYOUT_EMPTY_FULL
  | typeof LAYOUT_WITHOUT_SIDEBAR
  | undefined;
export interface setLayoutProp {
  type?: LayoutType;
  topElement?: ReactNode;
  bottomElement?: ReactNode;
}
export interface LayoutContextValue {
  layoutType: LayoutType;
  setLayout: ({ type, topElement }: setLayoutProp) => void;
}
